import GroupsIcon from '@mui/icons-material/Groups';
import { Avatar, SxProps, Theme } from '@mui/material';

type GroupIconProps = {
  avatarSx?: SxProps<Theme>;
  iconSx?: SxProps<Theme>;
};

export const GroupIcon = ({ avatarSx, iconSx }: GroupIconProps) => (
  <Avatar sx={avatarSx}>
    <GroupsIcon sx={iconSx} />
  </Avatar>
);
